module.exports = __webpack_public_path__ + "static/media/wifi_feature@3x.ac3acd3a.svg";